<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">groups</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ data.libelle }}</a>
        </div>
    </div>
</div>